import React from 'react';

import { getThirdPartyConnection } from '../../utils/activateUtr';
import { ratingTypes } from '../../utils/constants';
import Img from '../Img';

import styles from './activateUtrNotification.scss';

const ActivateUtrNotification = (props) => {
    const { type } = props;

    return (
        <div className={`${styles.activateUtrNotification}`} data-testid="activate-utr-notification">
            <div className={`${styles.notificationContainer}`}>
                <Img className={styles.partnershipLogo} src={getThirdPartyConnection(type)?.partnershipLogo} data-testid="activate-utr-notification.logo" />
                <div className={styles.activateTitle} data-testid="activate-utr-notification.title">
                    To activate your {ratingTypes.tennis} rating, connect a UTR Sports account.
                </div>
            </div>
        </div>
    );
};

export default ActivateUtrNotification;
